import { generarPDFCotizaciones } from '../utils/quotationPdf';
import { axiosInstance } from './axiosConfig';
import type { CotizacionResponse } from './landing/cotizacionService';

// Recovery proofs live in the Django database session, identified by an HttpOnly cookie.
let recovery: Promise<void> | null = null;
export const recuperarMisCotizaciones = (): Promise<void> => {
    if (recovery) return recovery;
    recovery = (async () => {
        let pending: boolean;
        do {
            const { data } = await axiosInstance.post<{ pendientes_sesion?: boolean }>('mis-cotizaciones/recuperar/', {});
            pending = data.pendientes_sesion === true;
        } while (pending);
    })().finally(() => { recovery = null; });
    return recovery;
};
export type CotizacionCliente = CotizacionResponse['cotizacion'];
export const listarMisCotizaciones = async (page = 1): Promise<{ count: number; results: CotizacionCliente[] }> => {
    await recuperarMisCotizaciones();
    const { data } = await axiosInstance.get('mis-cotizaciones/', { params: { page } });
    return data;
};
export const oficializarMiCotizacion = async (id: number): Promise<CotizacionResponse> => {
    const { data } = await axiosInstance.post(`mis-cotizaciones/${id}/oficializar/`);
    return data;
};
export const descargarPDFCotizacion = async (quote: CotizacionCliente) => {
    const { data } = await axiosInstance.get<CotizacionCliente>(`mis-cotizaciones/${quote.id}/`);
    const blob = await generarPDFCotizaciones([data]);
    if (!blob) throw new Error('No se pudo generar el PDF.');
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url; link.download = `cotizacion-${quote.codigo}.pdf`; document.body.appendChild(link); link.click(); link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
};
